import { render, staticRenderFns } from "./FlagFormContainer.vue?vue&type=template&id=927528e0&"
import script from "./FlagFormContainer.vue?vue&type=script&lang=js&"
export * from "./FlagFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./FlagFormContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports